// @ts-nocheck
import t from '@/store/types';

const initialState = {
  carrierId: null,
  trackingNumber: '',
  shippingQtys: {},
};

export default function packingSlipReducer(state = initialState, action) {
  switch (action.type) {
    case t.PACKING_SLIP_SET_CARRIER:
      return { ...state, carrierId: action.payload };

    case t.PACKING_SLIP_SET_TRACKING:
      return { ...state, trackingNumber: action.payload };

    case t.PACKING_SLIP_SET_SHIPPING_QTY:
      return {
        ...state,
        shippingQtys: {
          ...state.shippingQtys,
          [action.payload.itemId]: action.payload.qty,
        },
      };

    case t.PACKING_SLIP_RESET:
      return initialState;

    default:
      return state;
  }
}
